export default "__VITE_ASSET__D1ZKxNVv__"